import { JumpToModule } from './../../../../widgets/jump-to/jump-to.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxChartModule, DxDropDownButtonModule, DxTextAreaModule, DxRangeSelectorModule, DxDataGridModule, DxButtonModule, DxPopupModule, DxSwitchModule } from 'node_modules/devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { TaskListPopupModule } from 'src/app/pages/task/task-list-popup/task-list-popup.module';
import { TaskPopupModule } from 'src/app/pages/task/task-popup/task-popup.module';
import { SharedModule } from 'src/app/pipes/shared-module';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DxChartModule,
    DxDropDownButtonModule,
    DxTextAreaModule, DxRangeSelectorModule,
    DxDataGridModule,
    DevEpressCommonModule, SharedModule,
    DxButtonModule, DxPopupModule,
    TaskPopupModule, TaskListPopupModule,
    DxSwitchModule, BookmarkModule,
		
		JumpToModule,
  ]
})
export class DeepdiveV2Module { }
